import React from 'react';

interface GmgnChartProps {
  chain: 'sol' | 'eth' | 'blast';
  tokenAddress: string;
  tokenSymbol?: string;
  theme?: 'light' | 'dark';
  interval?: '1S' | '1' | '5' | '15' | '60' | '240' | '720' | '1D';
  width?: string | number;
  height?: string | number;
  className?: string;
}

const GmgnChart: React.FC<GmgnChartProps> = ({
  chain,
  tokenAddress,
  tokenSymbol,
  theme = 'dark',
  interval,
  width = '100%',
  height = '600px',
  className = ''
}) => {
  // GMGN 차트 URL 생성
  const buildChartUrl = () => {
    let url = `https://www.gmgn.cc/kline/${chain}/${tokenAddress}?interval=1`;
    const params = new URLSearchParams();
    
    if (theme) {
      params.append('theme', theme);
    }
    
    if (interval) {
      params.append('interval', interval);
    }

    // 토큰 심볼이 있으면 URL에 추가
    if (tokenSymbol) {
      params.append('symbol', tokenSymbol);
    }
    
    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }
    
    return url;
  };

  const chartUrl = buildChartUrl();

  return (
    <div className={`gmgn-chart-container ${className}`}>
      <iframe
        src={chartUrl}
        width={width}
        height={height}
        frameBorder="0"
        allowFullScreen
        className="rounded-lg shadow-lg"
        title={`GMGN Chart - ${chain.toUpperCase()} ${tokenSymbol || tokenAddress}`}
      />
    </div>
  );
};

export default GmgnChart; 